import React from 'react';

const STATUS_COLORS = {
  Completed: { bg: '#f0fdf4', text: '#059669' },
  Pending:   { bg: '#eff6ff', text: '#2563eb' },
  Running:   { bg: '#fffbeb', text: '#d97706' },
  Cancelled: { bg: '#fef2f2', text: '#dc2626' },
};

const StatusChip = ({ status }) => {
  const c = STATUS_COLORS[status] || STATUS_COLORS.Pending;
  return (
    <span style={{
      display: 'inline-block',
      backgroundColor: c.bg, color: c.text,
      borderRadius: 2, fontSize: 8, fontWeight: 700,
      padding: '1px 5px',
    }}>
      {status}
    </span>
  );
};

export default StatusChip;
